export type PersonNameOrder = "given_first" | "family_first"

const localeToNameOrderMap = new Map<string, PersonNameOrder>([
  ["ja-JP", "family_first"],
])

export interface FormatPersonNameParams {
  firstName?: string | null
  lastName?: string | null
  locale?: string | null
}

const normalizeNamePart = (value?: string | null): string | undefined => {
  const trimmed = value?.trim()
  if (!trimmed) {
    return undefined
  }

  return trimmed
}

export const resolvePersonNameOrder = (
  locale?: string | null
): PersonNameOrder => {
  if (!locale) {
    return "given_first"
  }

  const directOrder = localeToNameOrderMap.get(locale)
  if (directOrder) {
    return directOrder
  }

  const languagePrefix = locale.split("-")[0]
  for (const [mapLocale, order] of localeToNameOrderMap) {
    if (mapLocale.split("-")[0] === languagePrefix) {
      return order
    }
  }

  return "given_first"
}

export const formatPersonName = ({
  firstName,
  lastName,
  locale,
}: FormatPersonNameParams): string => {
  const givenName = normalizeNamePart(firstName)
  const familyName = normalizeNamePart(lastName)
  const order = resolvePersonNameOrder(locale)

  const parts =
    order === "family_first" ? [familyName, givenName] : [givenName, familyName]

  return parts.filter(Boolean).join(" ")
}

export const formatPersonNameInitials = ({
  firstName,
  lastName,
  locale,
}: FormatPersonNameParams): string => {
  const givenName = normalizeNamePart(firstName)
  const familyName = normalizeNamePart(lastName)
  const order = resolvePersonNameOrder(locale)

  const parts =
    order === "family_first" ? [familyName, givenName] : [givenName, familyName]

  const initials: string[] = []

  for (const part of parts) {
    if (part !== undefined) {
      initials.push(part.charAt(0))
    }
  }

  return initials.join("")
}
